import { api } from './client';

export type AddExternalOrderBody = {
  externalId: string;
  firstName: string;
  ticketCount: number;
};

export const addExternalOrder = (body: AddExternalOrderBody) =>
  api.post<{ externalOrder: AddExternalOrderBody }>('/admin/external-orders', body);

export type ImportExternalOrdersConflict = {
  externalId: string;
  firstName: string;
  ticketCount: number;
  incomingFirstName: string;
  incomingTicketCount: number;
  orderedShirts: number;
};

export type ImportExternalOrdersResult = {
  total: number;
  added: number;
  updated: number;
  unchanged: number;
  conflicts: ImportExternalOrdersConflict[];
  /** Rows the server dropped for a missing number or name. */
  skipped: number;
  dryRun: boolean;
};

/** Sends the file as-is; the server parses it. `dryRun` reports the outcome without writing. */
export const importExternalOrdersCsv = (csv: string, { dryRun = false } = {}) =>
  api.postCsv<ImportExternalOrdersResult>(
    `/admin/external-orders/import${dryRun ? '?dryRun=1' : ''}`,
    csv,
  );
